import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { PersonalDetailsService } from '../../customer/personal-details/personal-details.service';
import { TokenService } from '../../token/token.service';

import { environment } from '../../../environments/environment';
import { ChatCustomerDetails } from '../../customer/personal-details/contracts/personal-details';
import { LoginService } from 'app/login/login.service';

declare var window: any;
declare var $: any;

@Injectable()
export class ChatService {

  private name = null;
  private email = null;
  private extendedApiMerchantUrl = environment.credentials[0].client_id;

  constructor(private personalDetailsService: PersonalDetailsService, private tokenService: TokenService, private router: Router, private loginService: LoginService) { }

  getData() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.router.url.match(this.extendedApiMerchantUrl) || this.router.url.match(/widgets/) || (environment.customThemeMerchants.some(merchant => navigator.userAgent.includes(merchant)) || this.loginService.inIframe()) || (navigator.userAgent.includes('Ultra') || (navigator.userAgent.includes('GPay')))) {
          // Don't initialize olark if customer is seeing widgets or is on extended API merchant flow
          this.hideChatIcon();
        } else if (this.tokenService.getCustomerId()) {
          const personalDetailsData: ChatCustomerDetails = this.tokenService.getCustomerDetails();
          if (!personalDetailsData) {
            this.personalDetailsService.getPersonalDetailsV2().subscribe(response => {
              this.email = (response.Contact) ? response.Contact.EmailAddress : (response.MerchantCustomerDetails ? response.MerchantCustomerDetails.EmailAddress : null);
              this.name = (response.SocialDetails) ? response.SocialDetails.FullName : (response.MerchantCustomerDetails ? response.MerchantCustomerDetails.FullName : null);
              this.tokenService.setCustomerDetails(new ChatCustomerDetails(this.name, this.email));
              // //this.tokenService.setMixPanelUserId();
            });
          }
        }
      }
    });
  }
  showChatIcon() {
    if (window.ymConfig) {
      $('body').addClass('show-chat-icon');
    }
  }
  hideChatIcon() {
    if (window.ymConfig) {
      $('body').addClass('hide-chat-icon');
    }
  }
}
